import {remCalc} from '../../_utils'

export default {
    baseStyle: ({addressLength}: {addressLength: number}) => ({
        stack: {
            position: 'absolute',
            top: remCalc(-50),
            right: remCalc(0),
            gap: '0',
        },
        childrenFlex: {
            textStyle: 'body-medium',
            flexDirection: 'column',
        },
        cardContainer: {
            p: `${remCalc(24)} ${remCalc(20)} ${remCalc(20)} ${remCalc(20)}`,
            flexDirection: 'column',
            gap: remCalc(20),
            position: 'relative',
            cursor: 'pointer',
            border: 'small',
            borderStyle: 'solid',
            borderColor: 'border.light',
            minWidth: {lg: addressLength > 1 ? 'unset' : remCalc(451)},
        },
        radioCardFlexChild: {
            alignItems: 'center',
            gap: remCalc(9),
        },
        radioCardText: {
            textStyle: 'body-small',
            fontWeight: 'bold',
        },
        customRadioInputContainer: {
            h: remCalc(24),
            w: remCalc(24),
            border: 'small',
            borderStyle: 'solid',
            borderRadius: '50%',
        },
        customRadioInputContainerBull: {
            h: remCalc(12),
            w: remCalc(12),
            m: remCalc(5),
            borderStyle: 'solid',
            borderRadius: '50%',
            backgroundColor: 'background.dark',
        },
        addressName: {
            textStyle: 'body-medium',
            fontWeight: 500,
        },
        privacyText: {
            color: 'text.secondary',
            textStyle: 'body-small',
        },
        boxedCardContainer: {
            mb: remCalc(16),
        },
    }),
    variants: {
        'address-card': {
            closeButton: {
                position: 'absolute',
                top: remCalc(24),
                right: remCalc(20),
                display: 'flex',
            },
            actionCardStack: {
                maxW: {base: '100%', lg: remCalc(451)},
                padding: remCalc(20),
                paddingTop: remCalc(24),
                border: 'small',
                borderStyle: 'solid',
                borderColor: 'border.light',
            },
            checkboxDefault: {
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                gap: remCalc(8),
                label: {
                    fontSize: 'sm',
                    fontWeight: 'bold',
                },
            },
        },
        boxed: {
            stack: {
                position: 'absolute',
                top: remCalc(8),
                right: remCalc(15),
                gap: '0',
            },
            editPosition: {
                position: 'absolute',
                top: remCalc(24),
                right: remCalc(20),
            },
        },
        checkout: {
            editPosition: {
                position: 'absolute',
                top: remCalc(-48),
                right: remCalc(6),
            },
        },
    },
    parts: [
        'actionCardStack',
        'cardContainer',
        'stack',
        'childrenFlex',
        'radioCardFlexChild',
        'radioCardText',
        'customRadioInputContainer',
        'customRadioInputContainerBull',
        'closeButton',
        'checkboxDefault',
        'editPosition',
    ],
}
